import React from 'react';
import { fb } from 'form';
import { useForm } from 'form';
import "./variantList.scss";

export function Variants({ data, variants, setVariants, variantAttrs }) {
  //console.log(variants)
  const form = useForm(getVariantForm(variants), { onControlChanged: onControlChanged });

  function onControlChanged(e, control) {
    //console.log(form.getValue())
    //console.log('oncontrol changed')
    setVariants([...form.getValue()])
    // const newModel = getVariantForm(form.getValue())
    // form.reset(newModel)
  }
  
  
  React.useEffect(() => {
    //console.log('--useEffect')
    const newModel = getVariantForm(variants)
    form.reset(newModel)
    // eslint-disable-next-line
  }, [variants]);


  // function generateAll() {
  //   const variants = variantAttrs.reduce(getCombReducer, [])
  //   console.log(variants)
  //   setVariants([...variants])
  //   form.reset(getVariantForm(variants))
  // }

  const variantLines = form.model.controls;
  //console.log(form, variantLines)
  const render = (name, parent = null) => form.renderControl(name, parent);
  const val = (name, parent = null) => { const control = form.findControl(name, parent); return control? control.value : null};

  return <div className="variantList">
    <table>
      <thead>
        <tr>
          <th>Variant Name</th>
          <th>SKU</th>
          <th>Inventory<div>(empty = infinite)</div></th>
          <th>Price (inc Tax)<div>(empty = default)</div></th>
          <th>Enabled</th>
        </tr>
      </thead>
      <tbody>
        {(variantLines || []).map((item, index) => <tr key={index} className={`variant-${val('enabled', item)? 'enabled' : 'disabled'}`}>
          <td className="title">{render('title', item)}</td>
          <td className="sku">{render('sku', item)}</td>
          <td className="inventory">{render('inventory', item)}</td>
          <td className="price">{render('price', item)}</td>
          <td className="enabled">{render('enabled', item)}</td>
        </tr>)}
      </tbody>
    </table>
{/* 
    <div>
      <input type="button" className="btn btn-outline-primary btn-sm" value="Populate All" onClick={generateAll} />
    </div> */}
  </div>
}

function getVariantForm(variants) {
  const variantLines = [];
  variants.forEach(variant => {
    const line = fb.group({
      productVariantId: [variant.productVariantId],
      title: [getVariantTitle(variant)],
      variantOptions: [variant.variantOptions],
      sku: [variant.sku || '', [], { type: 'text', label: null }],
      inventory: [variant.inventory || '', [], { type: 'number', label: null }],
      price: [variant.price || '', [], { type: 'number', label: null }],
      enabled: [!!variant.enabled, [], { type: 'checkbox', label: null }],
    })
    variantLines.push(line);
  })

  return fb.array(variantLines)
}

function getVariantTitle(variant) {
  return variant.variantOptions.map(x => x.value).join('/')
}